/**
 * Constants used throughout the Open Financial Framework
 * @class F2.Constants.Css
 * @static
 */
export default {
	/**
	 * The APP class should be applied to the DOM Element that surrounds the
	 * entire app, including any extra html that surrounds the APP\_CONTAINER
	 * that is inserted by the container. See the
	 * {{#crossLink "F2.ContainerConfig"}}{{/crossLink}} object.
	 * @property APP
	 * @type string
	 * @static
	 * @final
	 */
	APP: 'f2-app',
	/**
	 * The APP\_CONTAINER class should be applied to the outermost DOM Element
	 * of the app.
	 * @property APP_CONTAINER
	 * @type string
	 * @static
	 * @final
	 */
	APP_CONTAINER: 'f2-app-container'
};
